import { render, staticRenderFns } from "./wapp.vue?vue&type=template&id=2b2cad9a"
import script from "./wapp.vue?vue&type=script&lang=js"
export * from "./wapp.vue?vue&type=script&lang=js"
import style0 from "./wapp.vue?vue&type=style&index=0&id=2b2cad9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports